module.exports = __webpack_public_path__ + "img/32.2d9aa782.jpg";